import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="relative pt-6 pb-6 sm:pt-10 sm:pb-12 px-4 overflow-hidden flex flex-col justify-center bg-gradient-to-b from-brand-sage-light to-brand-cream" data-id="element-108">
      <div className="max-w-2xl mx-auto text-center relative z-10" data-id="element-109">
        {/* Eyebrow */}
        <motion.div initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} className="inline-flex items-center gap-2 bg-brand-olive/10 border border-brand-olive/30 px-3 py-1 sm:px-4 sm:py-1.5 rounded-full mb-3 sm:mb-5" data-id="element-110">
          <span className="text-xs sm:text-sm font-bold tracking-wider text-brand-olive uppercase leading-tight" data-id="element-111">
            LANCIO 2026 · Risparmia il 70% solo oggi
          </span>
        </motion.div>

        {/* Headline */}
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.05
      }} className="text-2xl sm:text-4xl md:text-5xl font-serif font-bold text-brand-text-main leading-[1.15] mb-3 sm:mb-5" data-id="element-112">
          Basta stress in cucina. Ritrova energia e leggerezza con il sistema
          "Apri e Applica".
        </motion.h1>

        {/* Subheadline */}
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1
      }} className="text-sm sm:text-lg text-brand-text-muted leading-relaxed mb-4 sm:mb-6 max-w-xl mx-auto font-medium" data-id="element-113">
          Il primo metodo di organizzazione alimentare che ha già semplificato
          la vita a oltre 1.500 persone in Italia. Mangia bene, risparmia tempo
          e goditi il tuo stile di vita.
        </motion.p>

        {/* Product image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.15
      }} className="mb-4 sm:mb-6" data-id="element-114">
          <a href="#pricing" className="block cursor-pointer group" data-id="element-115">
            <img src="https://cdn.magicpatterns.com/uploads/xp8hWLP94c89qYGzRTZU3T/my-project-page-1_(11).png" alt="Metodo Mediterraneo Kit" className="w-full h-auto object-contain drop-shadow-2xl group-hover:scale-[1.02] transition-transform duration-500" data-id="element-116" />
          </a>
        </motion.div>

        {/* Main CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2
      }} data-id="element-117">
          <CTAButton className="w-full sm:w-auto sm:min-w-[300px]" variant="primary" data-id="element-118">
            🚀 SÌ, VOGLIO IL MIO RESET MEDITERRANEO
          </CTAButton>
        </motion.div>

        {/* Trust line */}
        <div className="flex flex-wrap justify-center items-center gap-x-2 gap-y-1 mt-3 sm:mt-5 text-[10px] sm:text-sm text-brand-text-muted font-medium" data-id="element-119">
          <span data-id="element-120">Accesso immediato</span>
          <span className="text-brand-text-muted/50" data-id="element-121">•</span>
          <span data-id="element-122">Pagamento sicuro</span>
          <span className="text-brand-text-muted/50" data-id="element-123">•</span>
          <span data-id="element-124">Garanzia 7 giorni</span>
        </div>
      </div>
    </section>;
}